export const findMaximumBipartiteMatching = (
  adjacency: number[][],
  rightCount: number,
): Map<number, number> => {
  const rightToLeft = new Map<number, number>();

  const tryAssign = (leftIndex: number, visited: Set<number>): boolean => {
    for (const rightIndex of adjacency[leftIndex]) {
      if (rightIndex < 0 || rightIndex >= rightCount) continue;
      if (visited.has(rightIndex)) continue;
      visited.add(rightIndex);
      const occupant = rightToLeft.get(rightIndex);
      if (occupant === undefined || tryAssign(occupant, visited)) {
        rightToLeft.set(rightIndex, leftIndex);
        return true;
      }
    }
    return false;
  };

  for (let leftIndex = 0; leftIndex < adjacency.length; leftIndex += 1) {
    tryAssign(leftIndex, new Set());
  }

  return rightToLeft;
};
